import { createSlice } from "@reduxjs/toolkit";
import { DropdownItem } from "pepsico-ds";
import {
  getPregeneratedQuestions,
  getRoles,
  getSectors,
} from "../../actions/appData/appDataAction";
import { ROLES } from "../../../config/roles";
import { safeJSONParser } from "../../../utils/parser";

interface AppDataState {
  isLoading: boolean;
  isError: boolean;
  roles: DropdownItem[];
  sectors: DropdownItem[];
  sampleQuestions: string[];
}

const initialState: AppDataState = {
  isLoading: false,
  isError: false,
  roles: [],
  sectors: [],
  sampleQuestions: [],
};

const appDataReducer = createSlice({
  name: "appData",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getRoles.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getRoles.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        const { data, hasAdmin } = action.payload;
        const roles = data.roles.map((role) => ({
          displayText: role.name,
          id: role.id.toString(),
        }));
        // is user has admin role, show all roles
        if (hasAdmin) {
          state.roles = roles;
        } else {
          state.roles = roles.filter(
            (role) =>
              role.displayText === ROLES.gpLead.displayText ||
              role.displayText === ROLES.basicUser.displayText
          );
        }
      })
      .addCase(getRoles.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
    builder
      .addCase(getSectors.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getSectors.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        const { data, hasAdmin, gpLeadSectors } = action.payload;
        if (hasAdmin) {
          state.sectors = data.sectors.map((sector) => ({
            displayText: sector.name,
            id: sector.id.toString(),
          }));
        } else {
          state.sectors = data.sectors
            .map((sector) => ({
              displayText: sector.name,
              id: sector.id.toString(),
            }))
            .filter((sector) => gpLeadSectors.includes(sector.displayText));
        }
      })
      .addCase(getSectors.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
    builder
      .addCase(getPregeneratedQuestions.pending, (state) => {
        state.isLoading = true;
        state.isError = false;
      })
      .addCase(getPregeneratedQuestions.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        const data = action.payload;
        const parsed = safeJSONParser(data.pregeneratedQuestions);
        state.sampleQuestions = parsed ? parsed : [];
      })
      .addCase(getPregeneratedQuestions.rejected, (state) => {
        state.isLoading = false;
        state.isError = true;
      });
  },
});
export default appDataReducer.reducer;
